import { useQuery } from "react-query";
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";
import { getData } from "../../../../newApis/dotNetApiMethods";

export interface IUserPosition {
  id: number;
  name: string;
}

export interface IUserPositionsResponse {
  data: IUserPosition[];
}

export const getUserPositions = async (): Promise<IUserPositionsResponse> => {
  const { data } = await getData(ajaxEndpoints.DB_GET_USER_POSITIONS);
  return data;
};

const useUserPositions = () => {
  return useQuery<IUserPositionsResponse>(["userPositions"], getUserPositions, {
    staleTime: 600000, // 10 minutes
  });
};

export default useUserPositions;
